import * as S from './styles'

interface TitleProps {
  name: string
  cancelCallback: () => void
}

const Title = ({ name, cancelCallback }: TitleProps) => {
  return (
    <S.EditTitleContainer className="flexbox v-centered h-spaced">
      <strong>{name}</strong>
      <button
        id="btn_close"
        type="button"
        onClick={cancelCallback}
        className="modal-close"
      >
        <span className="material-icons">close</span>
      </button>
    </S.EditTitleContainer>
  )
}

export default Title
